"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
class Registry {
    constructor() {
        this.entries = new Map();
        if (Registry.instance) {
            return Registry.instance;
        }
        Registry.instance = this;
        return this;
    }
    static getInstance() {
        if (!Registry.instance) {
            Registry.instance = new Registry();
        }
        return Registry.instance;
    }
    get size() {
        return Registry.instance.entries.size;
    }
    set(key, value) {
        const entries = Array.isArray(key) ? key : [{ [key]: value }];
        entries.forEach((entry) => {
            Object.entries(entry).forEach(([key, value]) => Registry.instance.entries.set(key, value));
        });
    }
    get(key) {
        if (!Registry.instance.entries.has(key)) {
            if (utils_1.config().debug) {
                console.warn(`Registry Error: ${key} is not available in the registry.`);
            }
            return null;
        }
        return Registry.instance.entries.get(key);
    }
    has(key) {
        return Registry.instance.entries.has(key);
    }
    clear() {
        Registry.instance.entries.clear();
    }
    delete(key) {
        return Registry.instance.entries.delete(key);
    }
    __jest__destroyInstance() {
        if (process.env.NODE_ENV !== 'test')
            return;
        delete Registry.instance;
    }
}
exports.default = Registry;
//# sourceMappingURL=Registry.js.map